/*
 * @Description: 中文说明
 * @Author: l_hc
 * @LastEditors: l_hc
 * @Date: 2019-07-07 11:17:27
 * @LastEditTime: 2019-07-24 14:28:18
 */
import { Page } from '@/utils/commonDataModel'

import { logistice } from '@/utils/request'
import { LOGISTICE_GATEWAY } from '@/utils/settings' // 请求接口

const prefix = `${LOGISTICE_GATEWAY}/website`

/* 保存数据的地址  */
const saveUrl = `${prefix}/personal/transport/cmsTransport/transport/`

/* 个人中心中过去运力列表的地址 */
const getTransportInManagerUrl = `${prefix}/personal/transport/cmsTransport/transport/`

/* 分页获取数据的地址  */
const findListUrl = `${prefix}/personal/transport/cmsTransport/webTransport`

/*  获取详情接口  */
const getDetailsUrl = `${prefix}/personal/transport/cmsTransport/transport/`

// 批量发布
const batchIssueUrl = `${prefix}/personal/transport/cmsTransport/transport/`

/* 删除数据的地址  */
const deleteUrl = `${prefix}/personal/transport/cmsTransport/transport/`

/* 批量删除接口  */
const batchDelUrl = `${prefix}/personal/transport/cmsTransport/transport/`

const getTransportUrl = `${prefix}/index/personal/transport/cmsTransport/webTransport`

const getOfferGoodsUrl = `${prefix}/personal/cmsgoodsOffer/findPageList`

export const getTransportList = (page, params) => {
  return logistice.post(getTransportUrl, undefined, { serialize: false, params: { params: Object.assign({ 'methodName': 'findPageList' }, params, page || new Page()) }})
}

// 平台协议
export function findCmsPlatformProtocol(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + '/website/index/cmsPlatformProtocolManager',
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findCmsPlatformProtocol'
      }, param))
    }
  })
}
// 平台协议 是否已经不再提示
export function upateStatus(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + '/website/index/cmsPlatformProtocolManager',
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'upateStatus'
      }, param))
    }
  })
}
/* 保存数据 */
export const save = (params) => {
  return logistice.post(saveUrl, undefined, { serialize: false, params: { params: Object.assign(params, { 'methodName': 'save' }) }})
}

// 获取运力列表
export const getTransportPageList = (page, params) => {
  return logistice.post(findListUrl, undefined, { serialize: false, params: { params: Object.assign({ 'methodName': 'findPageList' }, params, page || new Page()) }})
}

/* 获取详情 */
export const getDetails = (id) => {
  return logistice.post(getDetailsUrl, undefined, { serialize: false, params: { params: Object.assign({ id: id }, { 'methodName': 'getById' }) }})
}

/*  批量发布或下架 */
export const batchIssueAndRevoke = (params) => {
  return logistice.post(batchIssueUrl, undefined, { serialize: false, params: { params: Object.assign({ 'methodName': 'batchIssueAndCanal' }, params) }})
}

/* 删除数据 */
export const del = (params) => {
  return logistice.post(deleteUrl, undefined, { serialize: false, params: { params: Object.assign(params, { 'methodName': 'deleteById' }) }})
}

/* 批量删除数据 */
export const batchDel = (params) => {
  return logistice.post(batchDelUrl, undefined, { serialize: false, params: { params: Object.assign({ 'methodName': 'batchDel' }, params) }})
}

/* 个人中心中获取运力列表 */
export const getTransportInManager = (page, params) => {
  return logistice.post(getTransportInManagerUrl, undefined, { serialize: false, params: { params: Object.assign({ 'methodName': 'findPage' }, params, page || new Page()) }})
}

export const getOfferGoods = (page, params) => {
  return logistice.post(getOfferGoodsUrl, undefined, { serialize: false, params: { params: Object.assign({ 'methodName': 'findList' }, params, page || new Page()) }})
}
